import { FeatureSwitches } from "models/FeatureSwitches"
import { useApiData } from "./useApiData"

const useFeatureSwitches = () => {
  const { data, ...rest } = useApiData<FeatureSwitches>(`feature-switches/`)
  return { features: data, ...rest }
}

export default useFeatureSwitches
